// @flow
import SignUp from './SignUp';
export default SignUp;



// WEBPACK FOOTER //
// ./src/scenes/SignUp/index.js